import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import Header from "../../partials/header";
import {
  Grid,
  Collapse,
  List,
  ListItemSecondaryAction,
  ListItemText,
  ListItem,
  ListItemIcon,
  Checkbox,
  IconButton,
} from "@material-ui/core";
import {
  Folder,
  ExpandLess,
  ExpandMore,
  VisibilityOff,
} from "@material-ui/icons";
import Form from "./form";
import Loading from "../loading";
import MultiLevelCategoryList from "./multiLevelCategoryList";
export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: {},
      noRecordCategory: true,
      collapse: [],
      selected: [],
    };
  }
  async componentDidMount() {
    this.getProductCategory();
    this.getProduct();
  }
  getProductCategory = async () => {
    this.loading.startLoading();
    let result = await this.props.getProductCategory();
    if (
      result &&
      Array.isArray(result.allItems) &&
      result.allItems.length !== 0
    ) {
      this.setState({ noRecordCategory: false });
    }
    this.loading.stopLoading();
  };
  getProduct = async () => {
    this.loading.startLoading();
    await this.props.getProduct();
    this.loading.stopLoading();
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
  };
  handleListProduct = (id) => {
    let find = this.props.notLevelCategories.find((e) => e.id === id);
    this.setState({ selectedCategory: find });
  };
  handleUpdateForm = async (data) => {
    let inputFile = this.form.getInputFile();
    let files = inputFile.files;
    let src = inputFile.src;
    this.loading.startLoading();
    if (files !== null) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: files,
        code: this.props.serviceCode,
        type: "img-product-category",
      });
      if (checkUpload.code === 1) {
        data.image = checkUpload.data.previewLink;
      }
    } else if (src !== null) {
      data.image = src;
    } else if (inputFile.flagEdit && files === null && data.image) {
      data.image = "";
    }
    data.parent_id = data.parent_id || null;
    await this.props.updateProductCategory(data);
    this.getProductCategory();
    this.getProduct();
  };
  handleDeleteForm = async (data) => {
    this.loading.startLoading();
    await this.props.deleteProductCategory(data);
    this.setState({ selectedCategory: {} });
    this.getProductCategory();
    this.getProduct();
  };
  handleOpenCollapes(id) {
    const collapse = this.state.collapse;
    if (collapse.indexOf(id) !== -1) collapse.splice(collapse.indexOf(id), 1);
    else collapse.push(id);
    this.setState(collapse);
  }
  renderItem = (item, menuLevel) => {
    const { classes, disabled = false } = this.props;
    const { selected, collapse, selectedCategory } = this.state;
    const isSelected = selected.indexOf(item.id) >= 0 ? true : false;

    return [
      <ListItem
        style={{ cursor: "pointer", paddingLeft: `${menuLevel * 16}px` }}
        key={`menu-${item.id}`}
        role={undefined}
        divider={false}
        className={selectedCategory.id === item.id ? classes.selectedItem : ""}
        onClick={() => this.handleListProduct(item)}
      >
        <ListItemIcon>
          {item.enabled ? <Folder /> : <VisibilityOff />}
        </ListItemIcon>
        <ListItemText
          dense="true"
          primary={`${item.name}`}
          className={classes.menuName}
          className={classes.limit}
        />
        <ListItemSecondaryAction>
          {item.subMenu && item.subMenu.length ? (
            <IconButton onClick={() => this.handleOpenCollapes(item.id)}>
              {collapse.indexOf(item.id) != -1 ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </IconButton>
          ) : (
            ""
          )}
        </ListItemSecondaryAction>
      </ListItem>,
      <Collapse
        in={collapse.indexOf(item.id) != -1}
        key={`collapse-${item.id}`}
      >
        {Array.isArray(item.subMenu) &&
          item.subMenu.length > 0 &&
          item.subMenu.map((item) => {
            return this.renderItem(item, menuLevel + 1);
          })}
      </Collapse>,
    ];
  };
  render() {
    const { t, classes, listProductCategory = [] } = this.props;
    let { selectedCategory = {}, noRecordCategory } = this.state;
    return (
      <>
        <Header
          session={t("sidebar_service_and_product")}
          title={t("product_category")}
          backIcon={true}
          actionBack={() => this.props.history.push("/productMenu/list")}
          button={t("product_create")}
          actionButton={() =>
            this.props.history.push("/productMenu/category/create")
          }
        />
        {/* <Paper> */}
        <Loading onRef={(id) => (this.loading = id)} />
        {!noRecordCategory && (
          <Grid container spacing={0}>
            <Grid item xs={12} sm={3} md={3} lg={3}>
              <MultiLevelCategoryList handleListItem={this.handleListProduct} />
            </Grid>
            <Grid item xs={12} sm={9} md={9} lg={9}>
              {selectedCategory.id || listProductCategory.length ? (
                <Form
                  onRef={(id) => (this.form = id)}
                  data={
                    selectedCategory.id
                      ? selectedCategory
                      : listProductCategory.length
                      ? listProductCategory[0]
                      : {}
                  }
                  handleUpdateForm={this.handleUpdateForm}
                  handleDeleteForm={this.handleDeleteForm}
                />
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        )}
        {/* </Paper> */}
      </>
    );
  }
}

const mapState = (state) => ({
  listProductCategory: state.productCategory.listProductCategory,
  serviceCode: state.user.user.roleId.serviceCode,
  notLevelCategories: state.productCategory.notLevelCategories,
});

const mapDispatch = (dispatch) => ({
  getProductCategory: dispatch.productCategory.getProductCategory,
  getProduct: dispatch.product.getProduct,
  deleteProductCategory: dispatch.productCategory.deleteProductCategory,
  updateProductCategory: dispatch.productCategory.updateProductCategory,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(ProductMenu)));
